module.exports = "/assets/data/923ce4977b9eb39d5014438727d3f27b-TN7.data.json";